import { Logger } from './logger/Logger';
export let rootLogger = null;
export const originalConsole = {
    info: window.console.info,
    log: window.console.log,
    debug: window.console.debug,
    warn: window.console.warn,
    error: window.console.error
};
export const bindConsole = (toLogger) => {
    // Pipe window console through the logger
    window.console.info = (...args) => toLogger.info(...args);
    window.console.log = (...args) => toLogger.info(...args);
    window.console.debug = (...args) => toLogger.debug(...args);
    window.console.warn = (...args) => toLogger.warn(...args);
    window.console.error = (...args) => toLogger.error(...args);
};
export const createRootLogger = (transports, shouldBindConsole = true) => {
    rootLogger = new Logger('root', transports);
    if (shouldBindConsole) {
        bindConsole(rootLogger);
    }
    return rootLogger;
};
export const createLogger = (loggerName) => {
    if (!rootLogger) {
        throw new Error('Root logger instance not found. Call `createRootLogger` first, or use your own instance.createLogger instead.');
    }
    const childLogger = rootLogger.createLogger(loggerName);
    return childLogger;
};
